import axios from "axios";
import { API_URL } from "../utils/ApiLinks";

const getAuthHeaders = (contentType = "multipart/form-data") => ({
  "Content-Type": contentType,
  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
});

export const publishProperty = async (formData: FormData) => {
  for (const pair of formData.entries()) {
    // No mostrar las fotos completas para evitar logs enormes
    if (pair[0] === "Photos") {
      console.log("Photos: [Archivos de imagen]");
    } else {
      console.log(`${pair[0]}: ${pair[1]}`);
    }
  }

  try {
    const response = await axios.post(
      `${API_URL}/PropertyListing/create-property`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    return response;
  } catch (error: any) {
    console.error("Error al publicar propiedad:", error);

    if (error.response) {
      console.error("Respuesta de error del servidor:", {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
      });
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor:", error.request);
    } else {
      console.error("Error al configurar la solicitud:", error.message);
    }

    handleAuthError(error);
    return undefined;
  }
};

export const getProperties = async (
  page: number,
  pageSize: number,
  companyId?: number | null
) => {
  try {
    // Construir URL con query opcional
    const url = `${API_URL}/PropertyListing/get-all-properties/${page}/${pageSize}${
      companyId ? `?companyId=${companyId}` : ""
    }`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });

    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return { items: [], totalCount: 0 };
  }
};


export const getPropertyById = async (id: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/PropertyListing/get-property/${id}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};

export const getUserPropertyPosts = async (userId: number, companyId?: number) => {
  if (!userId) {
    console.error("getUserPropertyPosts: userId is required");
    return undefined;
  }

  try {
    // Construir la URL con los parámetros requeridos
    let url = `${API_URL}/PropertyListing/get-user-property-posts?userId=${userId}`;
    if (companyId) {
      url += `&companyId=${companyId}`;
    }

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });

    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};



export const getPropertyCountByCategory = async (companyId?: number) => {
  try {
    // Construir query string si companyId está definido
    const query = companyId ? `?companyId=${companyId}` : "";

    const response = await axios.get(
      `${API_URL}/PropertyListing/get-property-count-by-category${query}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};


export const updatePropertyData = async (field: string, formData: FormData) => {
  try {
    console.log(`🔄 Actualizando campo: ${field}`);
    for (const pair of formData.entries()) {
      console.log(`📝 ${pair[0]}:`, pair[1]);
    }

    const response = await axios.post(
      `${API_URL}/PropertyListing/update-${field}`,
      formData,
      { headers: getAuthHeaders() }
    );

    console.log("✅ Respuesta del servidor:", response.data);
    return response;
  } catch (error: any) {
    console.error("❌ Error al actualizar propiedad:", error);
    handleAuthError(error);
  }
};

export const updateCommissionData = async (
  propertyId: number,
  data: { commission: string; comissionType: number }
) => {
  try {
    console.log("data", data)
    const response = await axios.post(
      `${API_URL}/PropertyListing/update-commission/${propertyId}`,
      data
    );

    if(response.status === 200){
      return {success : response.data.success, message: response.data.message}
    }
  } catch (error: any) {
    console.log(error.response.data.message)
    return {success: false, message: error.response.data.message}
  }
};

export const deletePropertyById = async (formData: FormData) => {
  try {
    const response = await axios.post(
      `${API_URL}/PropertyListing/delete-property`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );
    return response;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};

export const searchPropertiesListing = async (query: string) => {
  try {
    const response = await axios.get(
      `${API_URL}/PropertyListing/search?query=${encodeURIComponent(query)}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return { items: [], totalCount: 0 };
  }
};

export const downloadPropertyImagesAsZip = async (
  idProperty: string,
  imageKeys: string[]
) => {
  try {
    const requestData = {
      idProperty,
      imageKeys,
    };

    const response = await axios.post(
      `${API_URL}/PropertyListing/download-property-photos-zip`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        responseType: "blob",
      }
    );

    const zipBlob = new Blob([response.data], { type: "application/zip" });
    const downloadUrl = URL.createObjectURL(zipBlob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `fotos_propiedad_${idProperty}.zip`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Liberar el objeto URL
    URL.revokeObjectURL(downloadUrl);
  } catch (error: any) {
    handleAuthError(error);
    console.error("Error downloading images as ZIP:", error);
  }
};

const handleAuthError = (error: any) => {
  console.log(error);
  if (error.response) {
    throw new Error(error.response.data.message || error.message);
  } else {
    throw new Error(error.message || "An unknown error occurred");
  }
};
